import { api } from "@/lib/api";

export const TOKEN_KEY = "v2050_ic_token";
export const UTM_KEY = "v2050_ic_utm";

export const INTERESTS = ["Land & development projects", "Real estate credit", "Both", "Just exploring"];
export const RANGES = ["Under €1,000", "€1,000–€5,000", "€5,000–€25,000", "€25,000–€100,000", "€100,000–€250,000", "€250,000–€1 million", "€1 million+", "Not sure yet"];
export const COMMS = [
    ["opportunities", "Selected investment opportunities only."],
    ["opportunities_updates", "Investment opportunities and occasional behind-the-scenes updates."],
];
export const STATUSES = ["Started", "Registered", "Qualified for follow-up", "Contacted"];
export const FOLLOW_UPS = ["None", "To follow up", "Waiting for reply", "Closed"];
export const INSTAGRAM = "https://www.instagram.com/pietervanherpen/";
export const DISCLAIMER = "Joining The Investor Circle is free and does not constitute an investment commitment or guarantee access to investment opportunities. Any future investment will be subject to applicable legal requirements, eligibility checks, and availability.";

const CODES = "AF AX AL DZ AD AO AI AG AR AM AW AU AT AZ BS BH BD BB BY BE BZ BJ BM BT BO BA BW BR BN BG BF BI CV KH CM CA KY CF TD CL CN CO KM CG CD CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FO FJ FI FR GF PF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI XK KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG MK NO OM PK PW PS PA PG PY PE PH PL PT PR QA RE RO RU RW BL KN LC MF PM VC WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA KR SS ES LK SD SR SE CH SY TW TJ TZ TH TL TG TO TT TN TR TM TC TV UG UA AE GB US UY UZ VU VA VE VN VG VI YE ZM ZW";
const names = new Intl.DisplayNames(["en"], { type: "region" });
export const COUNTRIES = CODES.split(" ").map((c) => names.of(c)).sort((a, b) => a.localeCompare(b));

export function captureUtm() {
    const q = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => { if (q.get(k)) utm[k] = q.get(k); });
    if (Object.keys(utm).length) sessionStorage.setItem(UTM_KEY, JSON.stringify(utm));
    if (!sessionStorage.getItem("v2050_ic_ref")) sessionStorage.setItem("v2050_ic_ref", document.referrer || "");
}

export function attribution() {
    let utm = {};
    try { utm = JSON.parse(sessionStorage.getItem(UTM_KEY) || "{}"); } catch { /* noop */ }
    return { utm, referrer: sessionStorage.getItem("v2050_ic_ref") || "", landing_path: window.location.pathname + window.location.search };
}

const auth = () => ({ headers: { "X-Circle-Token": localStorage.getItem(TOKEN_KEY) || "" } });
export const circleApi = {
    start: (body) => api.post("/investor-circle/start", body).then((r) => r.data),
    session: () => api.get("/investor-circle/session", auth()).then((r) => r.data),
    prefs: (body) => api.put("/investor-circle/preferences", body, auth()).then((r) => r.data),
    complete: (body) => api.post("/investor-circle/complete", body, auth()).then((r) => r.data),
};

export function errorText(err, fallback = "Something went wrong. Please try again.") {
    const d = err?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
    return fallback;
}
